var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderId, staticClass: "quick-reply-message-editor" },
    [
      _c("TiptapEditor", {
        attrs: {
          placeholder: _vm.$t("chatbotv2.enterYourMessage"),
          "show-attributes": _vm.showAttributes,
          "show-emoji": _vm.showEmoji,
          "max-character-count": 640,
          "whatsapp-mode": _vm.whatsappMode,
          "allowed-attributes": _vm.allowedAttributes,
          "show-emoji-picker": _vm.showEmojiPicker,
        },
        model: {
          value: _vm.clone.message,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "message", $$v)
          },
          expression: "clone.message",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "quick-replies" },
        [
          _vm._l(_vm.clone.buttons, function (button, i) {
            return _c(
              "div",
              { key: button.id, staticClass: "quick-reply" },
              [
                _c(
                  "a-popover",
                  {
                    key: button.id,
                    attrs: {
                      visible: _vm.editingButtonPopupVisibleMap[button.id],
                      placement: "left",
                      trigger: "click",
                      overlayClassName: "no-padding",
                    },
                    on: {
                      visibleChange: function (e) {
                        return _vm.visibleChange(button.id, e)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("ActionButtonUpdater", {
                          attrs: {
                            "on-completed": function () {
                              _vm.editingButtonPopupVisibleMap[
                                button.id
                              ] = false
                            },
                            "popup-visible":
                              _vm.editingButtonPopupVisibleMap[button.id],
                            "allowed-message-types": [
                              "SEND_MESSAGE",
                              "GO_TO_BLOCK",
                              "OPEN_URL",
                              "PHONE_CALL",
                              "OPEN_MOMENT",
                              "CLOSE_CHAT",
                              "TRANSFER_CHAT",
                              "CREATE_TICKET",
                            ],
                            flattedDiagram: _vm.flattedDiagram,
                            "whatsapp-mode": _vm.whatsappMode,
                            "allowed-attributes": _vm.allowedAttributes,
                          },
                          model: {
                            value: _vm.clone.buttons[i],
                            callback: function ($$v) {
                              _vm.$set(_vm.clone.buttons, i, $$v)
                            },
                            expression: "clone.buttons[i]",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "quick-reply-text" }, [
                      _vm._v(_vm._s(button.title)),
                    ]),
                    _vm._v(" "),
                    _vm.clone.buttons.length > 1
                      ? _c(
                          "div",
                          { staticClass: "button-controls" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-mini",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeButton(button.id)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("delete_outline")])],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.previewMode
            ? _c(
                "div",
                {
                  staticClass: "quick-reply-add",
                  on: { click: _vm.addButton },
                },
                [_vm._v("+" + _vm._s(_vm.$t("chatbotv2.addButton")))]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }